import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AssistantChat from "../common/AssistantChat/AssistantChat";
import { setIsActive } from "../chatbot/cl_ChatbotSlice";

const ChatPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Force chat to be active when on /chat page
  useEffect(() => {
    dispatch(setIsActive(true));
  }, [dispatch]);

  const handleCloseChat = () => {
    dispatch(setIsActive(false));
    navigate("/");
  };

  return (
    <div className="chat-page-container" style={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: "#181c3a"
    }}>
      <AssistantChat onClose={handleCloseChat} />
    </div>
  );
};

export default ChatPage;